import intlTelInput from 'intl-tel-input';

const defaultOptions = {
  loadUtils: () => import('intl-tel-input/utils'),
  strictMode: true,
  nationalMode: true,
  countrySearch: true,
  allowDropdown: true,
  separateDialCode: true,
  autoPlaceholder: 'aggressive',
  placeholderNumberType: 'MOBILE',
  customPlaceholder: (selectedCountryPlaceholder) => selectedCountryPlaceholder,
  hiddenInput: () => ({ phone: 'phone' }),
  initialCountry: 'auto',
  geoIpLookup: (success, failure) => {
    fetch('https://ipapi.co/json')
      .then((res) => res.json())
      .then(({ country_code }) => success(country_code))
      .catch(() => failure());
  },
};

const initIntlTelInput = (element, options) => {
  return intlTelInput(element, {
    ...defaultOptions,
    ...options,
  });
};

export default initIntlTelInput;
